import React from 'react';
import {problemFormFields} from "../../network/mockData";
import BasicResource from "../cmsbase/BasicResource";


function Issues(props) {


    return (
        <BasicResource
            dataUrl={props.dataUrl}
            addNewButton={props.addNewButton}
            downloadExport={true}
            exportUrl={props.exportUrl}
            exportFileName={props.exportFileName}
            tableFields={props.tableFields}
            extraElements={props.children}
            entityUrl="problem/admin/problems"
            dropdownDataUrls={{
                states: "problem/admin/states",
                categories: "problem/categories",
            }}
            formFields={problemFormFields}
            submitUrl="problem/admin/problems"
        />

    );
}

export default Issues;

